import { Box } from '@mui/material'
import cx from 'classnames'

import CustomCheckbox from '../../../../../../CustomCheckbox'
import DeleteIcon from '../../../../../../Icons/DeleteIcon'
import CustomSliderV2 from '../../../../../../Form/CustomSliderV2'
import HtmlTooltip from '../../../../../../HtmlTooltip'

import { useListItem } from './hooks/useListItem'
import FixedBidControls from './components/FixedBidControls'
import { formatRankValue } from '../../../../helpers/format-rank-value'

import useStyles from './style'

const formatValue = (value) => {
  if (value === null) {
    return 'NA'
  }

  return value
}

const formatDecimalValue = (value, isPercent) => {
  if (value === null) {
    return 'NA'
  }

  const formattedValue = value?.toFixed(Number.isInteger(value) ? 0 : 2) || 0

  return isPercent ? `${formattedValue}%` : formattedValue
}

const ListItem = ({
  id,
  searchPhrase,
  currentSearchVolume,
  currentOrganicRank,
  currentImpressions,
  currentImpressionShare,
  currentAdvertisingRank,
  currentClicks,
  currentConversions,
  currentACoS,
  currentBidFactor,
  currentBidFactorInit,
  currentFixedBid,
  type,
}) => {
  const {
    fixedBidExact,
    fixedBidPhrase,
    fixedBidBoard,
    updateFixedBidValue,
    updateBidFactor,
    isFixedBid,
    setIsFixedBid,
    changeBidMode,
    deleteItem,
    isBol,
  } = useListItem({ id, currentFixedBid, currentBidFactor, currentBidFactorInit, searchPhrase, type })
  const classes = useStyles()

  return (
    <Box
      className={cx(classes.box, {
        [classes.open]: isFixedBid,
      })}
    >
      <Box className={classes.box__inner}>
        <Box className={classes.col}>{searchPhrase}</Box>
        <Box className={classes.col}>
          <HtmlTooltip title={currentSearchVolume?.asOf}>{formatValue(currentSearchVolume?.value)}</HtmlTooltip>
        </Box>
        <Box className={classes.col}>
          <HtmlTooltip title={currentImpressions?.asOf}>{formatValue(currentImpressions?.value)}</HtmlTooltip>
        </Box>
        <Box className={classes.col}>
          <HtmlTooltip title={currentImpressionShare?.asOf}>
            {formatDecimalValue(currentImpressionShare?.value, false)}
          </HtmlTooltip>
        </Box>
        <Box className={classes.col}>
          <HtmlTooltip title={currentOrganicRank?.asOf}>{formatRankValue(currentOrganicRank?.value)}</HtmlTooltip>
        </Box>
        <Box className={classes.col}>
          <HtmlTooltip title={currentAdvertisingRank?.asOf}>
            {formatRankValue(currentAdvertisingRank?.value)}
          </HtmlTooltip>
        </Box>
        <Box className={classes.col}>
          <HtmlTooltip title={currentClicks?.asOf}>{formatValue(currentClicks?.value)}</HtmlTooltip>
        </Box>
        <Box className={classes.col}>
          <HtmlTooltip title={currentConversions?.asOf}>{formatValue(currentConversions?.value)}</HtmlTooltip>
        </Box>
        <Box className={classes.col}>
          <HtmlTooltip title={currentACoS?.asOf}>{formatDecimalValue(currentACoS?.value)}</HtmlTooltip>
        </Box>
        <Box className={classes.col}>
          <CustomSliderV2
            min={-3}
            max={6}
            value={currentBidFactor}
            onChange={updateBidFactor}
            hideLabel
            disabled={isFixedBid}
          />
        </Box>
        <Box className={classes.col}>
          <CustomCheckbox
            value={isFixedBid}
            onChange={(v) => {
              setIsFixedBid(v)
              changeBidMode(v)
            }}
          />
          <button type="button" onClick={deleteItem} className={classes.delete}>
            <DeleteIcon />
          </button>
        </Box>
      </Box>
      <Box className={classes.fixedCol}>
        <FixedBidControls
          displayControls={isFixedBid}
          isBol={isBol}
          fixedExactValue={fixedBidExact}
          fixedPhraseValue={fixedBidPhrase}
          fixedBoardValue={fixedBidBoard}
          onFixedBidExactUpdate={(v) => updateFixedBidValue('fixedBid_exact', v)}
          onFixedBidPhraseUpdate={(v) => updateFixedBidValue('fixedBid_phrase', v)}
          onFixedBidBoardUpdate={(v) => updateFixedBidValue('fixedBid_board', v)}
        />
      </Box>
    </Box>
  )
}

export default ListItem
